import { Select } from "antd";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAxios from "../../hooks/useAxios";
import { IGetSemesters } from "../../models/semesters.model";
import { getSemesters } from "../../api/semesters.api";
import useLoader from "../../hooks/useLoader";

interface IProps {
  semesterCode?: number;
  setSemesterCode: (value: number) => void;
  semesterType: string;
};

const SemesterSelect: FC<IProps> = ({
  semesterCode,
  setSemesterCode,
  semesterType
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSemesters>();
  useLoader(isLoading, [error]);

  useEffect(() => {
    execute(getSemesters());
  }, []);

  return (
    <Select
      placeholder={t('statistics.regularTest.placeholder2')}
      value={semesterCode}
      onChange={value => setSemesterCode(value)}
    >
      {res?.data?.filter(item => semesterType==='AL'? true : item.semesterType === semesterType ).map(item => (
        <Select.Option
          key={item.semesterCode}
          value={item.semesterCode}
        >
          {item.semesterName}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SemesterSelect;